import type { ReactNode } from 'react'
import { useBooleanFlagValue } from '../hooks/useBooleanFlagValue'
import { NuxTooltipProvider } from './NuxTooltipProvider'

export const NUX_TOOLTIPS_ENABLED_FLAG = 'nux_tooltips_enabled'

export function NuxTooltipGate({ children }: { children: ReactNode }) {
  const enabled = useBooleanFlagValue(NUX_TOOLTIPS_ENABLED_FLAG, false)
  return <NuxTooltipProvider enabled={enabled}>{children}</NuxTooltipProvider>
}
